export default function ({commit, dispatch}, value) {
    if (!value) return;
    commit('form/set', value.form);
    if (value.search) dispatch('search');
}